const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "核聚变2026深圳站"
const desc = "Ode to the gamer"

const cdnUrl = "https://site.gcores.com"
const DYNAMIC_URL_PLACEHOLDER = "__FUSION2026_DYNAMIC_URL_PLACEHOLDER__"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    dynamicUrlPlaceholder: DYNAMIC_URL_PLACEHOLDER,
    ticketUrl: "https://show.bilibili.com/platform/detail.html?id=1001491",
    mapUrl: "https://j.map.baidu.com/e0/ud6",
    // topicUrl: "https://www.gcores.com",
    newsTagId: "30307",
    videoUrl:
      "//player.bilibili.com/player.html?isOutside=true&aid=114792480117896&bvid=BV13p3VzNE82&cid=30901078750&p=1&autoplay=false",
  },
}
